import {
  ReferentielSearchResultDtoMarqueDto,
  SearchMarqueUsingSpecsUsingGETQueryParams,
} from 'lib_api/lib/api/gen';

import { searchMarque } from 'search/searchMarque';

import { useApi } from '../ApiStoreContext';

export function useSearchMarque(): (
  filters: SearchMarqueUsingSpecsUsingGETQueryParams,
) => Promise<ReferentielSearchResultDtoMarqueDto> {
  const controller = useApi().ReferentielControllerApi;

  return filters => {
    return searchMarque(controller, filters);
  };
}
